module.exports = "/images/use_cases.svg?888cae084ae31949da2bf817c5638859";